module.exports = __webpack_public_path__ + "images/icons/car.9ff3c6d8b41dc2058b6b0f7b87ce022a.svg";